import CustomMultiValueLabel from './custom_multi_value_label';

export {
  CustomMultiValueLabel
};
